export default __webpack_public_path__ + "static/media/background2.9e84ce47.png";